// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicCardStateControllerGetAllData } from './PublicCardStateControllerGetAllData.gen';
import type { PublicCardStateControllerGetAllErrors } from './PublicCardStateControllerGetAllErrors.gen';
import type { PublicCardStateControllerGetAllResponses } from './PublicCardStateControllerGetAllResponses.gen';

export class PublicCardStateController {
    /**
     * Get card possible states
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicCardStateControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicCardStateControllerGetAllResponses, PublicCardStateControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/card-states',
            ...options
        });
    }
}
